// ------------------------REGARDING FOR STATIC CONTENT  ------------------------------------------
import logoImage from '../assets/images/logo.png'; 
const websiteName = "CleanAbode";  
const websiteTagline = "Where Clean Meets Comfort.";  
const websiteUrl = "https://www.cleanAbode.com";  
const logoUrl = logoImage;
const androidAppLink = "android-app://com.cleanAbode.sura_user";
const iosAppLink = "ios-app://com.cleanAbode.sura_user";    
const currentLocation = sessionStorage.getItem('country');  
const currencyIcon = currentLocation === 'India' ? '₹' : '$';


// ----------------------- REGARDING FOR SEO / META TAG   -----------------------------------------------
window.logoUrl = logoImage;
window.dynamicAndroidAppLink = "https://play.google.com/store/apps/details?id=com.example";
window.dynamicIosAppLink = "https://apps.apple.com/us/app/example/id123456789";
window.dynamicWebsiteName = websiteName;
window.websiteTagline = 'Where Clean Meets Comfort.';
window.websiteUrl = 'https://www.cleanAbode.com';
window.metaOgDescription = `Discover ${websiteName}, your trusted partner in home and cleaning services, offering comprehensive solutions to maintain a clean, healthy, and comfortable living space...`;
window.metatwitterDescription = `Discover ${websiteName}, your trusted partner in home and cleaning services, supporting your journey to a cleaner and more comfortable home...`;
const metaDescriptionEn = `Discover ${websiteName}, your trusted partner in home and cleaning services, offering personalized care and comprehensive solutions to enhance the cleanliness and comfort of your living space...`;
const metaDescriptionTh = `ค้นพบ ${websiteName} พันธมิตรที่คุณวางใจในบริการทำความสะอาดบ้าน, ให้บริการดูแลแบบเฉพาะเจาะจงและครอบคลุมเพื่อเสริมสร้างความสะอาดและความสะดวกสบายในพื้นที่อยู่อาศัยของคุณ...`;

const keywordsTemplate = {
    en: {
      static: "Health Services, Wellness, Medical Care, Personalized Health Solutions",
      dynamic: `${websiteName}`
    },
    th: {
      static: "บริการสุขภาพ, ความเป็นอยู่ที่ดี, การดูแลทางการแพทย์, โซลูชั่นสุขภาพเฉพาะบุคคล",
      dynamic: `${websiteName}`
    }
  };
  



export {
  websiteName,
  websiteTagline,
  websiteUrl,
  logoUrl,
  currencyIcon,
  metaDescriptionEn,
  metaDescriptionTh,
  keywordsTemplate,
  androidAppLink,
  iosAppLink,
};